module.exports = __webpack_public_path__ + "static/media/p5.0cb747b6.jpeg";